const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
const Env = {
    environment: ENVIRONMENT,
    apiUrl: process.env.REACT_APP_API_BASE_URL
};
export const CUSTOMER_DOMAIN = process.env.REACT_APP_CUSTOMER_PORTAL_URL


export default Env;
